import React from "react";

/**
 * Signature gold rectangle frame around a content section.
 * Use `as="section"` to render different tags. The frame uses a thin gold border
 * with generous interior padding to feel editorial and boutique.
 */
export const Frame = ({
  children,
  as: Tag = "div",
  className = "",
  innerClassName = "",
  testId,
}) => {
  return (
    <Tag
      data-testid={testId}
      className={`sc-frame ${className}`}
    >
      <div className={`sc-frame-inner ${innerClassName}`}>{children}</div>
    </Tag>
  );
};

export default Frame;
